import { TCreateConverter, TFetchConverter } from '../types/converter.types';
import {
  EDevicesSources,
  EDevicesSourcesAsParam,
  EDevicesSourcesUi,
} from '../types/devicesEnum.type';

export const deviceSourceConverter: TFetchConverter<
  EDevicesSourcesUi,
  EDevicesSources
> = {
  fromDb: data => {
    const convertedDataMapper: {
      [key in EDevicesSources]: EDevicesSourcesUi;
    } = {
      [EDevicesSources.Manual]: EDevicesSourcesUi.Manual,
      [EDevicesSources.NinjaOne]: EDevicesSourcesUi.NinjaOne,
      [EDevicesSources.Level]: EDevicesSourcesUi.Level
    };
    return convertedDataMapper[data];
  },
};
export const deviceSourceAsParamConverter: TCreateConverter<
  EDevicesSourcesUi,
  EDevicesSourcesAsParam
> = {
  toDb: data => {
    const convertedDataMapper: {
      [key in EDevicesSourcesUi]: EDevicesSourcesAsParam;
    } = {
      [EDevicesSourcesUi.NinjaOne]: EDevicesSourcesAsParam.NinjaOne,
      [EDevicesSourcesUi.Manual]: EDevicesSourcesAsParam.Manual,
      [EDevicesSourcesUi.Level]: EDevicesSourcesAsParam.Level
    };
    return convertedDataMapper[data];
  },
};
